function normalizeCurrencyCode(currency?: string | null): string {
  const normalizedCurrency = currency?.trim().toUpperCase();

  return normalizedCurrency && normalizedCurrency.length > 0
    ? normalizedCurrency
    : "EUR";
}

export function formatCurrencyAmount(
  amount: number,
  currency?: string | null,
): string {
  const normalizedAmount = Number.isFinite(amount) ? amount : 0;
  const currencyCode = normalizeCurrencyCode(currency);

  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: normalizedAmount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: normalizedAmount % 1 === 0 ? 0 : 2,
    }).format(normalizedAmount);
  } catch {
    return `${normalizedAmount.toFixed(2)} ${currencyCode}`;
  }
}

export function getDiscountedServicePrice(
  price?: string | number | null,
  discount?: string | number | null,
): number {
  const normalizedPrice = Number(price ?? 0);
  const normalizedDiscount = Number(discount ?? 0);

  if (!Number.isFinite(normalizedPrice) || normalizedPrice <= 0) {
    return 0;
  }

  if (!Number.isFinite(normalizedDiscount) || normalizedDiscount <= 0) {
    return normalizedPrice;
  }

  return Math.max(
    normalizedPrice - (normalizedPrice * normalizedDiscount) / 100,
    0,
  );
}
